import React from 'react';

import cn from 'classnames';
import { MdDoneAll } from 'react-icons/md';

import type { HistoryItemType } from '@appTypes';
import {
  ActivityTypeIcon,
  AdvancementImage,
  Tooltip,
} from '@shared/components';
import { advancementStatuses, historyItemsTypes } from '@shared/constants';
import { intl } from '@shared/localization';

import styles from './PendingItemAdvancementName.less';

interface ComponentProps {
  type: HistoryItemType;
  showIcon?: boolean;
  item: {
    imgUrl?: string;
    advancementName: string;
    status: string;
    isJTE?: boolean;
    activityTypeId?: number;
    activityName?: string;
  };
}

function PendingItemAdvancementName(props: ComponentProps) {
  const { item, type, showIcon = false } = props;
  switch (type) {
    case historyItemsTypes.ADVANCEMENT: {
      return (
        <span>
          {showIcon && (
            <AdvancementImage src={item.imgUrl} className={styles.image} />
          )}
          {item.advancementName}
          {item.status === advancementStatuses.COUNSELOR_APPROVED && (
            <Tooltip
              title={intl.formatMessage({
                id: 'shared.AdvancementStatus.counselorApproved',
              })}
            >
              <MdDoneAll className={cn(styles.icon, styles.approved)} />
            </Tooltip>
          )}
        </span>
      );
    }
    case historyItemsTypes.ACTIVITY: {
      return (
        <span>
          {showIcon && (
            <ActivityTypeIcon
              isJTE={!!item.isJTE}
              activityTypeId={item.activityTypeId}
              className={styles.image}
            />
          )}
          {item.activityName}
        </span>
      );
    }

    default: {
      return null;
    }
  }
}

export default PendingItemAdvancementName;
